import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ReportProfileService} from '../../../../services/archive/report-profile.service';
import {ReportTask} from "../../../../model/archive/report-task";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {ArchiveFormAbsComponent} from "../archive-form-abs.component";
import {ClearingUtils} from "../../../../utils/clearing-utils";
import {DatePipe} from "@angular/common";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {NotificationService} from "../../../../services/security/notification.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {CcStorageService} from "../../../../services/common/cc-storage.service";
import {UserInfoStorageService} from "../../../../services/auth/user-info-storage.service";

@Component({
  selector: 'app-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['../archive-form-abs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportFormComponent extends ArchiveFormAbsComponent {

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              reportProfileService: ReportProfileService,
              translateService: TranslateService,
              reportTaskService: ReportTaskService,
              notificationService: NotificationService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              storageService: CcStorageService,
              userInfoStorageService: UserInfoStorageService,
              protected datePipe: DatePipe) {
    super(cdref, componentFactoryResolver, messageService, confirmationService, reportProfileService,
      translateService, reportTaskService, notificationService, commonFieldService, appConfigService, storageService,
      userInfoStorageService);
    super.origin = ReportTask.Origin.WEB_REPORT_FORM;
    super.transPartKey = 'archive-form';
  }


  protected setDateTo() {
    const yesterday = this.datePipe.transform(ClearingUtils.getYesterdayBusinessDate(), 'dd/MM/yyyy');
    this.formRecord.customStartDate = yesterday;
    this.formRecord.customEndDate = yesterday;
  }
}
